import { spinner } from "../../util/spinner/spinner";
import { CommonUtils } from "../../util/common-utils";
import { SearchMenuForm } from "./search-menu-form";

export class SearchMenuHandler {
    private static readonly form = new SearchMenuForm();
    private static readonly postsSearchBasePath = "/posts";

    private static getSearchTarget(form: HTMLFormElement): "products" | "posts" {
        const targetInput = this.form.getSearchMenuTargetInput(form);
        return targetInput?.checked ? "posts" : "products";
    }

    public static handleProductSearchSubmit(event: Event): void {
        event.preventDefault();

        const form = this.form.getSubmittedForm(event);
        if (!form) return;

        const input = this.form.getSearchFormInput(form);
        const submitBtn = this.form.getSubmitButton(form);
        const kw = String(input?.value || "").trim();
        const target = this.getSearchTarget(form);

        if (submitBtn && !submitBtn.hasAttribute("data-no-spinner") && !form.hasAttribute("data-no-spinner")) {
            spinner.showButtonLoader(submitBtn, { translateKey: "spinner_proccesing" });
        }

        setTimeout(() => {
            const params = new URLSearchParams();

            if (kw.length > 0) {
                params.set("search", kw);
            }

            const basePath = target === "posts" ? this.postsSearchBasePath : "/products";
            const url = params.toString() ? `${basePath}?${params.toString()}` : basePath;
            window.location.href = CommonUtils.resolveUrl(url);
        }, 100);
    }

    public static handleBoardSearchSubmit(event: Event): void {
        event.preventDefault();

        const form = this.form.getSubmittedForm(event);
        if (!form) return;

        const input = this.form.getSearchFormInput(form);
        const submitBtn = this.form.getSubmitButton(form);
        const kw = String(input?.value || "").trim();
        const boardId = String(form.dataset.boardId || "default");

        if (submitBtn && !submitBtn.hasAttribute("data-no-spinner") && !form.hasAttribute("data-no-spinner")) {
            spinner.showButtonLoader(submitBtn, { translateKey: "spinner_proccesing" });
        }

        setTimeout(() => {
            if (!kw) return;

            const url = `/posts/${boardId}/search/${encodeURIComponent(kw)}/page/1`;
            window.location.href = CommonUtils.resolveUrl(url);
        }, 100);
    }

    public static toggleClearButton(input: HTMLInputElement): void {
        const clearBtn = this.form.getSearchFormClearButton(input.form ?? input.parentElement ?? document);
        if (!(clearBtn instanceof HTMLElement)) return;

        if (input.value.trim().length > 0) {
            clearBtn.classList.add("show");
            return;
        }

        clearBtn.classList.remove("show");
    }

    public static clearProductSearch(form: HTMLFormElement): void {
        const input = this.form.getSearchFormInput(form);
        const clearBtn = this.form.getSearchFormClearButton(form);
        if (!input) return;

        input.value = "";
        if (clearBtn instanceof HTMLElement) {
            clearBtn.classList.remove("show");
        }
        input.dataset.suppressSearchMenuOpenOnce = "1";
        input.focus();
    }

    public static clearBoardSearch(form: HTMLFormElement): void {
        const input = this.form.getSearchFormInput(form);
        const clearBtn = this.form.getSearchFormClearButton(form);
        if (!input) return;

        input.value = "";
        if (clearBtn instanceof HTMLElement) {
            clearBtn.classList.remove("show");
        }
        input.dataset.suppressSearchMenuOpenOnce = "1";
        input.focus();
    }
}
